<template>
    <div class="fixed-scroller">
        <div class="v-alert w-1100">
            <header><p>Customer - <span style="font-weight: bold;">{{ item.name }}</span></p><div class="x" @click="exit"></div></header>
            <div class="grid-container">
                <div class="offers">
                    <p>Live Coupons</p>
                    <div v-for="ad in item.ads" class="ad-item">
                        <p class="td-ulb ellip ad-field" @click="showVoucher('ads',ad)">{{ ad.field || 'no title' }}</p>
                        <p class="ad-date">{{ ad.date > 0 && format(ad.date,"dd/MM/yy HH:mm") }}</p>
                    </div>
                </div> 
                <div class="redeems">
                    <p>Redeems</p>
                    <div v-for="ad in item.redeemRewards" class="ad-item">
                        <p class="td-ulb ellip ad-field" @click="showVoucher('redeemRewards',ad)">{{ ad.field || 'no title' }}</p>
                        <p class="ad-date">{{ format(ad.now,"dd/MM/yy HH:mm") }}</p>
                    </div>
                </div>
                <div class="awards">
                    <p>Stamps</p>
                    <div v-for="stamp in item.loyaltyAwards" class="ad-item award">
                        <p class="ellip">{{ stamp.name }}</p>
                        <p class="ta-r mr-10">{{ stamp.qty }}</p>
                        <p class="ta-r mr-10">{{ format(new Date(stamp.date),"dd/MM/yy HH:mm") }}</p>
                    </div>
                </div> 
            </div>          
        </div>
        <div v-if="voucher" class="voucher fixed-scroller">
            <div class="v-alert">
                <header><p>{{ voucher.type == 'ads' ? 'Offer' : 'Redeemed' }}</p><div class="x" @click="voucher = false"></div></header>
                <Voucher :voucher="voucher" />
                <div v-if="!voucher.redeemAd">
                    <p class="btn">remove</p>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>

import prettyPhone from '../utils/prettyPhone.js';
import { format } from 'date-fns'
import Voucher from '../components/Voucher';
import WebSoc from '../utils/WebSoc.js';

export default {
    props: ['item'],
    components: { Voucher },
    data () {
        return {
            voucher: false,
            format,
            name: '',
            email: '',
            phone: ''
        }
    },
    created () {
        var customer = this.item;
        var forceUpdate;
        (customer.redeemRewards || [] ).concat(customer.loyaltyAwards).forEach(award => {
            console.log('award',JSON.parse(JSON.stringify(award)));
            this.$set(award,'name','');
            var user_id = award.user_id;
            user_id && WebSoc.SEND('get',{ DB: 'users', _id: user_id, project: { name: 1 } },user => {
                this.$set(award,'name',user.name || 'no staff');
                console.log('award.name',award.name);
                clearTimeout(forceUpdate);
                //forceUpdate = setTimeout(this.forceUpdate,300)
            })
        })
    },
    mounted () {
        var customer = this.item;
        this.name = customer.name;
        this.email = customer.email;
        this.phone = prettyPhone(customer.phone);
        console.log('customer',JSON.parse(JSON.stringify(customer)));
    },
    methods: {
        showVoucher ( type, ad ) {
            WebSoc.SEND('get',{ DB: 'surveys', _id: ad.campaign_id },campaign => {
                if ( !campaign ) return console.log('!campaign');
                var Ad = campaign.pages.find(p => p.ad_id == ad.ad_id);
                    Ad.type = type;
                this.voucher = Ad;
            })
        },
        exit () {
            this.$emit('emit',{ t: 'customer', action: 'exit' });
        }
    }
}

</script>

<style scopped="true" lang="scss">
.voucher {
    &.fixed-scroller {
        z-index: 400;
        .v-alert {
            top: 100px;
            width: 315px;
            .ad-img {
                margin-bottom: -140px;
            }
            p.btn {
                width: calc(100% - 10px);
                line-height: 3;
            }
        }
    }
}
.grid-container {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
}

.contact {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.offers,.redeems,.awards {
    border-left: 1px solid #c0c0c0; 
    padding: 10px 0px;  
    > p { text-align: center; margin-bottom: 10px; } 
}
.offers,.redeems,.awards {
    .ad-item {
        width: calc(100% - 10px);
        float: left;
        padding: 3px 5px;
        p { float: left; }
        &:nth-child(even) { background-color: rgba(100,100,100,0.3); }
        p.ad-field { width: calc(100% - 122px); } 
        p.ad-date { width: calc(120px); }
    }
}
.awards {
    .ad-item {
        display: grid;
        gap: 10px;
        grid-template-columns: 1fr 40px 120px;
    }
}
</style>